import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.globalAirport;
}

export function useGlobalAirport() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
